// extracted by mini-css-extract-plugin
module.exports = {"root":"index_root__L-unC","monsters":"index_monsters__3L5nT","title":"index_title__2aXuU","message":"index_message__1trpw","link":"index_link__3C43W"};